import { HierarchyContextProps, IHierarchyActionSetClinicalLibraryLoading } from "../interface";

/**
 * Sets the clinical library loading flag.
 *
 * @param state - The current hierarchy context state.
 * @param action - The set-clinical-library-loading action to apply.
 * @returns The updated hierarchy context state.
 */
export const hcr_setClinicalLibraryLoading = (
  state: HierarchyContextProps,
  action: IHierarchyActionSetClinicalLibraryLoading,
): HierarchyContextProps => ({
  ...state,
  isClinicalLibraryLoading: action.isClinicalLibraryLoading,
});
